import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";

import Restaurants from "../pages/restaurants/restaurants.page";
import DetailsRestaurants from "../routing/detailRestaurant";
import NotFound from "../pages/404/404.page";

class RoutingRestaurants extends Component {
  render() {
    return (
      <Switch>
        <Route exact path={`/pt/restaurantes`} component={Restaurants} />
        <Route path={`/pt/restaurantes/:slug`} component={DetailsRestaurants} />

        <Route exact path={`/en/restaurants`} component={Restaurants} />
        <Route path={`/en/restaurants/:slug`} component={DetailsRestaurants} />

        <Route exact path={`/de/restaurants`} component={Restaurants} />
        <Route path={`/de/restaurants/:slug`} component={DetailsRestaurants} />

        <Route exact path={`/es/restaurantes`} component={Restaurants} />
        <Route path={`/es/restaurantes/:slug`} component={DetailsRestaurants} />

        <Route exact path={`/fr/restaurants`} component={Restaurants} />
        <Route path={`/fr/restaurants/:slug`} component={DetailsRestaurants} />

        <Route exact path={`/ja/restaurants`} component={Restaurants} />
        <Route path={`/ja/restaurants/:slug`} component={DetailsRestaurants} />

        <Route component={NotFound} />
      </Switch>
    );
  }
}

export default RoutingRestaurants;



// WEBPACK FOOTER //
// ./src/routing/restaurants.js